import React, { useState, useEffect, useCallback, useRef } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { detectDeviceType, getPassCode, checkAdmin, getCurrentUser, getUserNameOpt, checkApiError, resetOnlogout } from '../utils';
import ImagesAll from '../assets';
import Agenda from './Agenda';
import VenueContact from './VenueContact';
import TravelDetails from './TravelDetails';

import { formatDate, timeConvert } from './../common';
import { useAuth } from '../Context';

import { toast } from 'react-toastify';

import '../css/Home.css';

const Home = ({showLoading}) => {
  const { onLogoutContext } = useAuth();
  const location = useLocation();
  const { eventIsLive, eventId } = location.state || { eventIsLive: false, eventId: null };
  const isMobile = detectDeviceType().toLowerCase() === 'mobile';
  const isAdminLogin = checkAdmin();
  const currentUser = getCurrentUser();

  const [attendeesENCORIANS, setAttendeesENCORIANS] = useState([]);
  const [attendees, setAttendees] = useState([]);
  const cabMemberContainerRef = useRef(null); // Ref for the CAB member container
  const encoraMemberContainerRef = useRef(null); // Ref for the CAB member container
  const [showMoreCabMembers, setShowMoreCabMembers] = useState(false);
  const [showMoreEncorians, setShowMoreEncorians] = useState(false);
  const [selectedAttendee, setSelectedAttendee] = useState(null);
  const [selectTab, setSelectTab] = useState('CAB');
  const [isShowCabBtn, setIsShowCabBtn] = useState(true);
  const [isShowEncoraBtn, setIsShowEncoraBtn] = useState(true);

  const [queCharCount, setQueCharCount] = useState(0);
  const [queError, setQueError] = useState(null);

  const [eventDetail, setEventDetail] = useState({});
  const [agendaDetails, setAgendaDetails] = useState([]);
  const [coordinatorList, setCoordinatorList] = useState([]);
  const [showQueSentMsg, setShowQueSentMsg] = useState(false);
  const [showResndText, setShowResndText] = useState(false);
  
  const [noUpcomingOngoingEvent, setNoUpcomingOngoingEvent] = useState(false);

  const [eventInfo, setEventInfo] = useState({
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: ''
  });

  const getTimeZone = (_value) =>{
    const timeZones = [
      { name: "Pacific Time", value: "Pacific Standard Time" },
      { name: "Eastern Time", value: "Eastern Standard Time" },
      //{ name: "Indian Time (IT)", value: "India Standard Time" },
    ];

    const tz = timeZones.filter(item => item.value === _value)

    return tz.length > 0 ? `(${tz[0].name})` : `(${eventDetail.eventTimeZone})`;
  }  

  const [timer, setTimer] = useState(0);
  
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      // const question = document.getElementById('iQuestions');
      // question.value = '';
      // question.disabled = false;
      // setQueCharCount(0);
      // setQueError(null);
      setShowQueSentMsg(false);
    }
  }, [timer]);

  const navigate = useNavigate();

  const groupAgendasByDate = (_agendaList) => {
    if(_agendaList.length === 0){
      return;
    }
    const grouped = _agendaList.reduce((acc, item) => {
      const date = item.eventDate.split("T")[0];
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(item);
      return acc;
    }, {});
  
    const sortedDates = Object.keys(grouped).sort();    
    const sortedList = sortedDates.map((date) => ({
      eventDate: date,
      agendas: grouped[date].sort((a, b) => new Date(a.startTime) - new Date(b.startTime)),
    }));

    getStartEndDateTime(sortedList);
  };
    
  const getStartEndDateTime = (_sortedList) =>{
    const startDate = _sortedList[0].agendas[0].eventDate.split('T')[0];
    const startTime = timeConvert(_sortedList[0].agendas[0].startTime);

    _sortedList = _sortedList.filter(data => { return (data.agendas[data.agendas.length-1].teamsMeetingLink !== ""); });

    const last = _sortedList[_sortedList.length-1];
    const endDate = last.agendas[last.agendas.length-1].eventDate.split('T')[0];
    const endTime = timeConvert(last.agendas[last.agendas.length-1].endTime);
    setEventInfo({startDate:startDate, startTime:startTime, endDate:endDate, endTime:endTime});
  }

  const fetchEventAndAttendees = useCallback(async (_eventId) => {
    try {
      if (!getPassCode()) {
        navigate("/login");
        return;
      }

      showLoading(true);
      if(_eventId){
        // fetch details by using event id. (if current user is admin)
        const response = await fetch(`${process.env.REACT_APP_API_URL}/LearnerDashboard/GetAll?eventId=${_eventId}`, {
          headers: {
            'Authorization': `Bearer ${getPassCode()}`
          }
        });

        if(checkApiError(response.status)){ navigate("/login"); return; }
    
        if (response.status === 200) {
          const data = await response.json();
          setEventDetail(data.upcomingEvent[0] || {});
          setAttendees(data.cabMembers || []);
          setAttendeesENCORIANS(data.encoraLeaders || []);
          setAgendaDetails(data.agenda || []);
          setCoordinatorList(data.coordinator || []);
          groupAgendasByDate(data.agenda || []);
        }else{
          //toast.error('Error on Event details fetching by event id.');
          return;
        }
      }else{
        // fetch details by using current logged user id.
        //if(!currentUser.userId) return;
        const response = await fetch(`${process.env.REACT_APP_API_URL}/LearnerDashboard/GetAll?userId=${currentUser.userId}`, {
          headers: {
            'Authorization': `Bearer ${getPassCode()}`
          }
        });

        if(checkApiError(response.status)){ navigate("/login"); return; }
    
        if (response.status === 200) {
          const data = await response.json();
          setEventDetail(data.upcomingEvent[0] || {});
          setAttendees(data.cabMembers || []);
          setAttendeesENCORIANS(data.encoraLeaders || []);
          setAgendaDetails(data.agenda || []);
          setCoordinatorList(data.coordinator || []);
          groupAgendasByDate(data.agenda || []);
        }else{
          //toast.error('Error on Event details fetching by user id.');
          if(!_eventId) 
            setNoUpcomingOngoingEvent(true);
          return;
        }
      }
    } catch (e) {
      //toast.error('An error occurred!');
      if(!_eventId) 
        setNoUpcomingOngoingEvent(true);
    } finally {
      showLoading(false);
    }
  }, [navigate, currentUser.userId, showLoading]);

  useEffect(() => {
    fetchEventAndAttendees(eventId);
  }, []);
  //}, [eventId, fetchEventAndAttendees]); //removed dependencies: issue in admin view event when click on agenda

  useEffect(()=>{
    document.querySelector('.App').scrollTo(0,0);
  }, []);
  useEffect(() => {
    // After the component renders and attendees are loaded, adjust max-height
    if (cabMemberContainerRef.current && attendees.length > 0) {
      const firstCard = cabMemberContainerRef.current.querySelector('.attendee-card');
      if (firstCard) {
        const firstCardHeight = firstCard.offsetHeight + 30;
        cabMemberContainerRef.current.style.maxHeight = showMoreCabMembers ? 'none' : `${firstCardHeight}px`; // Set initial maxHeight
        if (cabMemberContainerRef.current.scrollHeight < firstCardHeight && !isMobile) {
          setIsShowCabBtn(false);
          cabMemberContainerRef.current.style.maxHeight = 'max-content'
        }
      }
    }
  }, [attendees, showMoreCabMembers, isMobile, selectTab]); // Add showMoreCabMembers to dependency array

  const showCABMemberContainer = (value) => { setSelectTab(value); };

  const toggleCabMembers = () => setShowMoreCabMembers(!showMoreCabMembers);
  useEffect(() => {
    // After the component renders and attendees are loaded, adjust max-height
    if (encoraMemberContainerRef.current && attendeesENCORIANS.length > 0) {
      const firstCard = encoraMemberContainerRef.current.querySelector('.card');
      if (firstCard) {
        const firstCardHeight = firstCard.offsetHeight + 30;
        encoraMemberContainerRef.current.style.maxHeight = showMoreEncorians ? 'none' : `${firstCardHeight}px`; // Set initial maxHeight

        if (encoraMemberContainerRef.current.scrollHeight < firstCardHeight && !isMobile) {
          setIsShowEncoraBtn(false);
          encoraMemberContainerRef.current.style.maxHeight = 'max-content';
        }
      }
    }
  }, [attendeesENCORIANS, showMoreEncorians, isMobile, selectTab]);
  const toggleEncorians = () => setShowMoreEncorians(!showMoreEncorians);

  const handleAttendeeEdit = (attendee) => setSelectedAttendee(attendee);

  const openLinkedInProfile = (_linkedInId) => window.open(_linkedInId, '_blank');

  const submitQuestion = async (e) => {
    if (queError) return;
    let isError = false;
    try {
      showLoading(true);
      e.target.disabled = true;

      const question = document.getElementById('iQuestions');

      // Use optional chaining to safely access coordinator details
      const coordinatorNames = coordinatorList?.map((c) => c.firstName+' '+c.lastName).join(',') || '';
      const coordinatorEmails = coordinatorList?.map((c) => c.emailId).join(',') || '';

      const queData = {
        questions: question.value.trim(),
        UserName: currentUser.firstName+' '+currentUser.lastName,
        EventName: eventDetail.eventTitle,
        CoordinatorName: coordinatorNames,
        CoordinatorEmail: coordinatorEmails,
        CreatedById: currentUser.userId,
        LastModifiedById: currentUser.userId
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL}/Question/Add`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getPassCode()}`,
        },
        body: JSON.stringify(queData),
      });

      if(checkApiError(response.status)){ navigate("/login"); return; }

      if (response.status === 200) {
        toast.success('Question submitted.');
        //question.disabled = true;
        question.value = '';
        setQueCharCount(0);
        setQueError(null);
        setShowQueSentMsg(true);
        setShowResndText(true);
        setTimer(30);
      } else {
        isError = true;
        toast.error('Question not submitted.');
      }
    } catch (error) {
      isError = true;
      toast.error('Question not submitted.');
    } finally {
      showLoading(false);
      isError && (e.target.disabled = false);
    }
  };

  const handleKeyDownToTextChange = (e) => {
    if (e.target.value.length === 0 && (e.keyCode === 32 || e.keyCode === 13)) {
      e.preventDefault();
      return;
    }
  }

  const handleQueTextChange = (e) => {
    const { value } = e.target;

    if (value.length === 1 && (value.charCodeAt(0) === 32 || value.charCodeAt(0) === 13)) {
      e.target.value = ''; //remove space and enter from value.
      setQueCharCount(0);
      return;
    }

    setQueCharCount(value.length);
    checkFieldValidate('nQuestions', value); // Consistent naming for validation
  };

  const checkFieldValidate = (name, value) => {
    const flag = !/^[a-zA-Z0-9\s-,.'&?/()]*$/.test(value);
    setQueError(flag ? "Special characters not allowed except (. , ' - & / ?)" : null);
  };

  if(noUpcomingOngoingEvent){
    document.querySelector('.cstm-navbar-container .mobile-menu-icon').style.display = 'none';
    document.querySelector('.cstm-navbar-container .user-profile.on-mobile').style.right = '1rem';
    const navEle = document.querySelector('.cstm-navbar-menu ul:first-child');
    navEle.style.visibility = 'hidden';
    navEle.pointerEvents = 'none';
    const logout = () => {
      onLogoutContext();
      resetOnlogout();
      navigate("/login");
    }
    return (
        <div className="Home w3-padding mb-4">
          <div id="home-section" className="home-section">
            <div className="w3-panel welcome-panel">
              <h4 className='color-purple roboto-medium'>Hi {getUserNameOpt()},</h4>
              <p className='color-purple m-0 fs-1-4 mt-4'>No upcoming or ongoing event found.</p>
              <p className='d-inline-block m-0 mt-4 fs-1-2' onClick={logout} style={{cursor: 'pointer'}}>Log out</p>
            </div>
          </div>
        </div>
      )
  }

  return (
    <div className="Home w3-padding mb-4">

      {/* Home Section */}
      <div id="home-section" className="home-section"> 
        <div className="w3-panel welcome-panel">
          <h4 className='color-purple roboto-medium'>Hi {getUserNameOpt()},</h4>
          <p className='color-purple m-0 fs-1-4'>{eventDetail.welcomeText}</p>
        </div>

        <div className="w3-card-4 w3-margin-bottom-2em w3-round">
          <div className='w3-container w3-white w3-round w3-padding-16 cab-event-panel'>
            { eventIsLive ? (
              <a target="_blank" className="wel-venue-image" href='https://www.ritzcarlton.com/en/hotels/hafrz-the-ritz-carlton-half-moon-bay/overview/'>
                <img className='w3-round-large' src={ImagesAll.OtherImages.ImgLive} alt="Event Location" style={{ width: '100%' }} />
              </a>
              ):(
                <a className="wel-venue-image pe-none" href='#'>
                 <img className='w3-round-large' src={ImagesAll.OtherImages.ImgVirtual} alt="Event Location" style={{ width: '100%' }} />
                </a>
              )
            }            
            <div>
              <h2 className='roboto-medium mb-3'>{eventDetail.eventTitle}</h2>
              <HashLink smooth to="#agenda-section" className='a-link'>
                { (formatDate(eventDetail.eventStartDate) === formatDate(eventDetail.eventEndDate)) ? (
                  <p className="date">{formatDate(eventDetail.eventStartDate)}</p>
                ):(
                  <p className="date">{formatDate(eventDetail.eventStartDate)} &mdash; {formatDate(eventDetail.eventEndDate)}</p>
                )}                
                { agendaDetails.length > 0 &&
                  <p className={`clock ${eventIsLive ? 'mb-3' : 'mb-0'}`}>{eventInfo.startTime} - {eventInfo.endTime} {getTimeZone(eventDetail.eventTimeZone)}</p>
                }
              </HashLink>
              { eventIsLive && (
                <HashLink smooth to="#venue-contact-section" className='a-link'>
                  <p className="location mb-0">The Ritz Carlton | Half Moon Bay</p>
                </HashLink>
                )
              }
            </div>
          </div>
        </div>
      </div>

      {/* CAB Members Section */}
      <div id="cab-member-section" className={`cab-member-section w3-card-4 w3-margin-bottom-2em w3-round`}>
        {isMobile ? (
          <div className="cls-tabs d-flex roboto-bold w3-white w3-round">
            <span onClick={()=> showCABMemberContainer("CAB") } className={`fs-1-1 ${selectTab === "CAB" ? 'active' : ''}`}>CAB MEMBERS</span>
            <span onClick={()=> showCABMemberContainer("ENCORA") } className={`fs-1-1 ${selectTab === "ENCORA" ? 'active' : ''}`}>ENCORA LEADERS</span>
          </div>
        ):(
          <></>
        )}

        {/* Show CAB Members */ }
        <div className={`w3-white p-0 p-md-3 ${isMobile ? '' : ''}`}>
          <div className={`full-container ${isMobile && (selectTab === "CAB" ? '' : 'hide')}`}>
            <div className='w3-container cab-member-cards'>
            {isMobile ? (
              <></>
            ):(
              <h4 className='roboto-bold'>CUSTOMER ADVISORY BOARD MEMBERS</h4>
            )}
              <div id='containerCABMembers' className={`card-container ${showMoreCabMembers ? 'expanded' : 'collapsed'}`} ref={cabMemberContainerRef}> {/* Add ref here */}
                {attendees.length > 0 && attendees.map((attendee) => (
                  <div className="card attendee-card" key={attendee.attendeeMappingId}>
                    <div className="w3-card-4 w3-white card-height w3-center w3-round">
                        { attendee.linkedInProfileURL && !eventIsLive &&
                          <div className="attendee-linkedin" onClick={() => openLinkedInProfile(attendee.linkedInProfileURL)}></div>
                        }

                        {isAdminLogin && eventIsLive ? (
                          <HashLink smooth to="#travel-section">                        
                            <div className="attendee-card-edit" onClick={() => handleAttendeeEdit(attendee)}></div>
                          </HashLink> 
                        ) : (<></>) }
                        <div className="cab-member-img w3-circle mb-2">
                          {(attendee.profilePhotoPath === null || attendee.profilePhotoPath === "") ? ( 
                            <img src={ImagesAll.Members.NoImg} alt="" className=""/>
                          ) : (
                            <img src={process.env.REACT_APP_API_URL+attendee.profilePhotoPath} alt="" className=""/>
                          )}
                        </div>
                      <div className="w3-padding-small card-details">
                        <h5 className='roboto-bold color-black'>{attendee.firstName+' '+attendee.lastName}</h5>
                        <p className="atn-title">{attendee.designation}</p>
                        {/* <p className="fs-0-8 color-purple atn-email t-d">{attendee.email}</p> */}
                        {(attendee.companyLogoPath === null || attendee.companyLogoPath === "") ? (
                          <p className='fw-500'>{attendee.organization}</p>
                        ):(
                          <img src={process.env.REACT_APP_API_URL+attendee.companyLogoPath} alt={attendee.organization + " Logo"} className="company-logo" />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                { attendees.length === 0 && 
                  <p className='text-start w-100'>CAB member not mapped for this event.</p>
                }
              </div>
              {attendees.length > 0 && isShowCabBtn && // <-- Added selectTab check
                <button className="load-more w3-round-xlarge color-blue w3-card-2" onClick={toggleCabMembers}>{ showMoreCabMembers ? (
                  <div><span>Show Less</span> <span className="arrow-up"></span></div>
                ) : (
                  <div><span>Show More</span> <span className="arrow-down"></span></div>
                )}</button>
              }
            </div>
          </div>
        </div>

        {/* Show Encora Members */ }
        <div className={`p-0 p-md-3 ${isMobile ? '' : ''}`}>
        <div className={`full-container ${isMobile && (selectTab === "ENCORA" ? 'w3-white' : 'hide')}`}>
          <div className='w3-container encora-member-cards'>
          {isMobile ? (
            <></>
          ):(
            <h4 className='roboto-bold'>ENCORA LEADERS</h4>
          )}
              <div id='containerEncoraMembers' className={`card-container ${showMoreEncorians ? 'expanded' : 'collapsed'}`} ref={encoraMemberContainerRef}>
              {attendeesENCORIANS.length > 0 && attendeesENCORIANS.map((attendee) => (
                !attendee.notShowInMembers &&
                <div className="card" key={attendee.userId}>
                  <div className="w3-card-4 w3-white card-height w3-center w3-round">
                      { attendee.linkedInProfileURL && !eventIsLive &&
                        <div className="attendee-linkedin" onClick={() => openLinkedInProfile(attendee.linkedInProfileURL)}></div>
                      }
                      {isAdminLogin && eventIsLive ? (
                        <HashLink smooth to="#travel-section">
                        <div className="attendee-card-edit" onClick={() => handleAttendeeEdit(attendee)}></div>
                        </HashLink>
                      ) : (<></>) }
                      <div className="cab-member-img w3-circle mb-2">
                      {(attendee.profilePhotoPath === null || attendee.profilePhotoPath === "") ? ( 
                          <img src={ImagesAll.Members.NoImg} alt="" className=""/>
                        ) : (
                          <img src={process.env.REACT_APP_API_URL+attendee.profilePhotoPath} alt="" className=""/>
                        )}
                      </div>
                    <div className="w3-padding-small card-details">
                      <h5 className='roboto-bold color-black'>{attendee.firstName+' '+attendee.lastName}</h5>
                      <p className="atn-title">{attendee.designation}</p>
                      {<p className="fs-0-9 color-purple atn-email t-d">{attendee.emailId}</p>}
                      <img src={ImagesAll.Logos.Encora} alt={"Encora Logo"} className="company-logo" />
                    </div>
                  </div>
                </div>
              ))}

             {attendeesENCORIANS.length === 0 && 
              <p className='text-start w-100'>Encora leaders not mapped for this event.</p>
             }
            </div>
              {attendeesENCORIANS.length > 0 && isShowEncoraBtn &&
              <button className="load-more w3-round-xlarge color-blue w3-card-2" onClick={toggleEncorians}>{ showMoreEncorians ? (
                <div><span>Show Less</span> <span className="arrow-up"></span></div>
              ) : (
                <div><span>Show More</span> <span className="arrow-down"></span></div>
              )}</button>
            }
          </div>
        </div>
        </div>        
      </div>

      {/* Agenda Section */}
      <div id="agenda-section" className="agenda-section" >
        <Agenda isEventLive = {eventIsLive} agendaDetails={agendaDetails} timeZone={getTimeZone(eventDetail.eventTimeZone)} /> 
      </div>

      { eventIsLive &&
        <>
          {/* Travel Section - Conditionally render TravelDetails */}
          <div id="travel-section" className="travel-section">
            <TravelDetails attendee={selectedAttendee} /> 
          </div>
        </>
      }
      {/* Venue & Contact Section */}
      <div id="venue-contact-section" className="venue-contact-section">
        <VenueContact isEventLive = {eventIsLive} coordinatorList={coordinatorList} />
      </div> 

      {/* question panel */ }
      <div id='question-section' className='event-question question-container w3-card-2 w3-margin-bottom w3-round w3-white w3-padding w3-padding-16'>
        <div className='p-0 p-md-3'>
          <h4 className='roboto-bold'>Have Questions? Share them in Advance</h4>
          <p>Submit your questions in advance to ensure they're addressed the meeting.</p>

          <div className='position-relative'>
            <textarea name="nQuestions" id="iQuestions" maxLength={500} rows={6} className={`cQuestions form-control ${queError && 'border-danger'}`} placeholder='Enter your question here...' onChange={handleQueTextChange} onKeyDown={handleKeyDownToTextChange} />
            <div className='cShow-char-len'>{queCharCount}/500</div>
          </div>
          {queError && <div className="text-danger small mt-1">{queError}</div>}
          <p></p>
          <p>
            <button type='button' id='que-submit-btn' className={`que-submit-btn btn btn-purple mb-2 me-2`} disabled={queCharCount === 0} onClick={submitQuestion}>
              {showResndText ? (
                <>
                  {/* <div className='sending'>Sending<span>.</span><span>.</span><span>.</span></div> */}
                  <span>Resend</span>
                </>
              ): (
                <span>Send</span>
              )}
            </button>
            {showQueSentMsg && <span className='color-gray'>Question sent.</span> }
            {/* <span className='small color-gray text-center ms-3'>00 : {timer === 0 ? '45' : timer < 10 ? '0'+timer : timer }</span> */}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
